export default __webpack_public_path__ + "static/media/portfolio-120.8d46bf27.jpg";